import {format} from 'date-fns';

import {Link, Text} from '#component/base';
import {ModalRoot, ModalTrigger} from '#component/base/Modal';
import {ContactUsModal} from '#component/modal';
import {sprinkles} from '#style/sprinkles';
import {formatAPIDate} from '#util';

import {StepProps} from '../../Register.types';
import {RegistrationStep} from '../RegistrationStep';
import {RegistrationStepBox} from '../RegistrationStepBox';

import * as css from './StepReview.css';

export const StepReview = ({onNext, onPrev, className, data, wizardData}: StepProps) => {
  const profile = data?.me.userProfile;
  const date = profile?.birthday ? formatAPIDate(profile.birthday, 'MM/dd/yyyy') : null;

  const handleEditClick = () => {
    onPrev?.('barcode-input');
  };

  return (
    <RegistrationStep
      className={className}
      prevText="Cancel"
      nextText="Confirm"
      onNext={onNext}
      onPrev={onPrev}>
      <RegistrationStepBox className={css.box}>
        <Text as="h2" color="deepBurgundy" variant="heading2">
          Confirm details
        </Text>

        <div className={css.content}>
          <div className={css.info}>
            <p className={sprinkles({mB: [16, 24]})}>
              <Text as="span" color="doveGray" fontWeight="semiBold">
                Please confirm the information we&apos;ve collected is correct.
              </Text>
              <ModalRoot>
                <Text as="span" color="doveGray">
                  To change your name or date of birth, please&nbsp;
                  <ModalTrigger asChild={true}>
                    <Text as="span" color="doveGray" className={css.contactSupport}>
                      contact support
                    </Text>
                  </ModalTrigger>
                  .
                </Text>
                <ContactUsModal />
              </ModalRoot>
            </p>
          </div>

          <div className={sprinkles({flex: 'flex', dir: 'col', gap: 32, grow: 1})}>
            <div>
              <div className={sprinkles({flex: 'flex', dir: 'row', items: 'center'})}>
                <Text as="div" variant="label" color="doveGray" className={sprinkles({grow: 1})}>
                  Vial Number
                </Text>
                <Text className={css.editLink}>
                  <Link as="button" onClick={handleEditClick}>
                    Edit
                  </Link>
                </Text>
              </div>
              <Text as="div" color="mineShaft" className={css.fakeInput()}>
                TH{wizardData.barcode}
              </Text>
            </div>
            <div>
              <Text as="div" variant="label" color="doveGray" className={sprinkles({grow: 1})}>
                Name
              </Text>
              <Text as="div" color="mineShaft" className={css.fakeInput({bgColor: true})}>
                {profile?.firstName} {profile?.lastName}
              </Text>
            </div>
            {date && (
              <div>
                <Text as="div" variant="label" color="doveGray" className={sprinkles({grow: 1})}>
                  Birthdate
                </Text>
                <Text as="div" color="mineShaft" className={css.fakeInput({bgColor: true})}>
                  {format(new Date(date), 'MMM dd, yyyy')}
                </Text>
              </div>
            )}
          </div>
        </div>
      </RegistrationStepBox>
    </RegistrationStep>
  );
};
